import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

import styles from './FormGrid.module.css';

/**
 * Two fields per row on wide screens, one on phones — keeps dialogs short so they rarely scroll.
 * Wrap a field in <FormGridWide> to give it the whole row (addresses, notes).
 */
export function FormGrid({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn(styles.grid, className)}>{children}</div>;
}

export function FormGridWide({ children }: { children: ReactNode }) {
  return <div className={styles.wide}>{children}</div>;
}
